import React from 'react';

export const fmt = (n) => Number(n).toLocaleString('en-US');
export const fmtCurrency = (n) => '$' + (n / 1_000_000).toFixed(1) + 'M';
export const fmtPct = (n, total) => ((n / total) * 100).toFixed(1) + '%';

export const Pill = ({ children, variant = 'default', className = '' }) => {
  const variants = {
    default:  'bg-stone-100 text-stone-700 border-stone-200',
    navy:     'bg-[#0a0a0a]/10 text-[#0a0a0a] border-[#0a0a0a]/20',
    gold:     'bg-[#DBC078]/20 text-[#7a5f1a] border-[#DBC078]/40',
    teal:     'bg-[#1F7A8C]/10 text-[#1F7A8C] border-[#1F7A8C]/20',
    burgundy: 'bg-[#7A1F2B]/10 text-[#7A1F2B] border-[#7A1F2B]/20',
    success:  'bg-emerald-50 text-emerald-700 border-emerald-200',
  };
  return (
    <span className={`inline-flex items-center px-2 py-0.5 text-xs font-medium border rounded uppercase tracking-wider ${variants[variant] || variants.default} ${className}`}>
      {children}
    </span>
  );
};

export const StatCard = ({ label, value, sublabel, icon: Icon, accent = 'navy' }) => {
  const accents = {
    navy: 'border-l-[#0a0a0a]', gold: 'border-l-[#DBC078]',
    teal: 'border-l-[#1F7A8C]', burgundy: 'border-l-[#7A1F2B]',
  };
  return (
    <div className={`bg-white border border-stone-200 border-l-4 ${accents[accent]} p-5`}>
      <div className="flex items-start justify-between mb-2">
        <div className="text-xs font-medium uppercase tracking-wider text-stone-500">{label}</div>
        {Icon && <Icon size={16} className="text-stone-400" />}
      </div>
      <div className="font-serif text-3xl text-[#0a0a0a] mb-1 font-serif-display">{value}</div>
      {sublabel && <div className="text-xs text-stone-500">{sublabel}</div>}
    </div>
  );
};

export const SectionHeader = ({ children, sub }) => (
  <div className="mb-4 pb-3 border-b border-stone-200">
    <h2 className="text-xl text-[#0a0a0a] font-serif-display">{children}</h2>
    {sub && <div className="text-xs text-stone-500 mt-1">{sub}</div>}
  </div>
);

export const CitationBlock = ({ children, source }) => (
  <div className="text-[10px] text-stone-500 mt-2 pl-2 border-l-2 border-[#DBC078]/40 italic">
    <span className="font-medium not-italic">Source:</span> {source}
    {children && <div className="mt-1">{children}</div>}
  </div>
);
